import React, { useEffect, useState } from 'react';
import { ArrowLeft, RefreshCw } from 'lucide-react';
import axios from '../../configApi/axiosConfig';
import { APIURL } from '../../configApi/apiConfig';

export function ReasignarReiterativoForm({ oportunidad, onBack, onSaved, onDirtyChange }) {
  const [vendedores, setVendedores] = useState([]);
  const [idVendedorNuevo, setIdVendedorNuevo] = useState('');
  const [motivo, setMotivo] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    axios.get(APIURL.getGestorVendedoresElegibles(oportunidad.idOportunidad))
      .then(response => { if (active) setVendedores(response.data || []); })
      .catch(err => {
        if (!active) return;
        const message = err?.response?.data?.message;
        setError(Array.isArray(message) ? message.join(' ') : message || 'No se pudieron consultar los vendedores disponibles.');
      })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [oportunidad.idOportunidad]);

  const submit = async event => {
    event.preventDefault();
    if (saving) return;
    if (!idVendedorNuevo || !motivo.trim()) {
      setError('Selecciona un vendedor e indica el motivo de la reasignación.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await axios.post(APIURL.postGestorReasignar(oportunidad.idOportunidad), {
        idVendedorNuevo: Number(idVendedorNuevo), motivo: motivo.trim(),
      });
      onDirtyChange(false);
      onSaved();
    } catch (err) {
      const message = err?.response?.data?.message;
      setError(Array.isArray(message) ? message.join(' ') : message || 'No fue posible reasignar la oportunidad.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mx-auto max-w-2xl">
      <button type="button" onClick={onBack} className="mb-5 inline-flex min-h-11 items-center gap-2 text-sm font-semibold text-morado hover:underline">
        <ArrowLeft size={16} /> Volver a la cola
      </button>
      <h3 className="text-xl font-bold text-slate-900">Reasignar Reiterativo</h3>
      <p className="mt-1 text-sm text-slate-600">{oportunidad.nombreCompleto} · {oportunidad.cedula}</p>
      <p className="mt-3 rounded-lg bg-amber-50 p-3 text-sm text-amber-900">La reasignación consume uno de los 10 cupos diarios del vendedor destino.</p>
      <form onSubmit={submit} className="mt-6 space-y-5">
        <label className="block text-sm font-semibold text-slate-700">
          Vendedor destino
          <select value={idVendedorNuevo} disabled={loading || saving} onChange={event => { setIdVendedorNuevo(event.target.value); onDirtyChange(true); }}
            className="mt-2 min-h-11 w-full rounded-lg border border-slate-300 bg-white px-3 text-sm focus:border-morado focus:outline-none focus:ring-2 focus:ring-morado/20">
            <option value="">Selecciona un vendedor de la misma bodega</option>
            {vendedores.filter(v => Number(v.cupoDisponible) > 0).map(v =>
              <option key={v.idPersonal} value={v.idPersonal}>{v.nombre} · {v.cupoDisponible} cupos disponibles</option>)}
          </select>
        </label>
        {loading && <p className="flex items-center gap-2 text-sm text-slate-600"><RefreshCw size={16} className="animate-spin" /> Cargando vendedores…</p>}
        {!loading && !vendedores.some(v => Number(v.cupoDisponible) > 0) && <p className="text-sm text-amber-800">No hay vendedores con cupo en esta bodega hoy.</p>}
        <label className="block text-sm font-semibold text-slate-700">
          Motivo
          <textarea value={motivo} maxLength={300} rows={4} disabled={saving} onChange={event => { setMotivo(event.target.value); onDirtyChange(true); }}
            className="mt-2 w-full rounded-lg border border-slate-300 p-3 text-sm focus:border-morado focus:outline-none focus:ring-2 focus:ring-morado/20" placeholder="Explica por qué se reasigna" />
          <span className="mt-1 block text-right text-xs font-normal text-slate-500">{motivo.length}/300</span>
        </label>
        {error && <p role="alert" className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</p>}
        <button type="submit" disabled={loading || saving || !vendedores.some(v => Number(v.idPersonal) === Number(idVendedorNuevo) && Number(v.cupoDisponible) > 0)}
          className="min-h-11 rounded-lg bg-morado px-5 text-sm font-bold text-white hover:bg-moradoHover disabled:cursor-not-allowed disabled:opacity-50">
          {saving ? 'Guardando…' : 'Guardar reasignación'}
        </button>
      </form>
    </div>
  );
}
